import { PaymentRequest } from "@stripe/stripe-js";

const STRIPE_PAYMENT_REQUEST_TIMEOUT = 3000;

/**
 * Simple function that wraps the PaymentRequest.canMakePayment method
 * to fail on a timeout
 * @param request PaymentRequest on which the API call will be made
 * @returns Promise returning a boolean, indicating if payment can be made.
 */
export async function wrappedCanMakePayment(request: PaymentRequest): Promise<boolean> {
    const abort = new AbortController();

    const timeoutId = setTimeout(() => {
        abort.abort("Payment Request API call timed out");
    }, STRIPE_PAYMENT_REQUEST_TIMEOUT);

    return new Promise((resolve, reject) => {
        if (abort.signal.aborted) {
            reject(abort.signal.reason);
        }

        request
            .canMakePayment()
            .then((result) => {
                clearTimeout(timeoutId);
                resolve(!!result);
            })
            .catch((error) => {
                clearTimeout(timeoutId);
                reject(error);
            });

        abort.signal.addEventListener("abort", () => {
            reject(abort.signal.reason);
        });
    });
}
